if (!customElements.get('results-grid')) {
  customElements.define(
    'results-grid',
    class ResultsGrid extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
      }

      connectedCallback () {
        super.connectedCallback()
        this.onProductsUpdated = this.renderProducts.bind(this)

        this.eventBus.subscribe(
          window.theme.results.events.STATE.PRODUCTS_UPDATED,
          this.onProductsUpdated,
        )
      }

      disconnectedCallback () {
        this.eventBus.unsubscribe(
          window.theme.results.events.STATE.PRODUCTS_UPDATED,
          this.onProductsUpdated,
        )
      }

      renderProducts ({ products, interaction }) {
        const list = this.querySelector('[data-results-grid-el="list"]')
        const items = list.querySelectorAll('.prd-List_Item')
        const totalItems = products.length
        const productsPerPage =
          window.theme.results.stateLayer.state.productsPerPage

        if (interaction === 'filter' || interaction === 'sort') {
          list.innerHTML = ''
          products.forEach((product, index) => {
            const listItem = document.createElement('li')
            listItem.className = 'prd-List_Item'
            listItem.innerHTML = window.theme.results.templates.ProductCard({
              product,
              index,
              type: 'results',
            })
            list.appendChild(listItem)
          })
        }

        if (interaction === 'initial') {
          list.style.contentVisibility = 'hidden'

          if (totalItems >= productsPerPage) {
            products.forEach((product, index) => {
              if (!items[index]) return
              items[
                index
              ].innerHTML = window.theme.results.templates.ProductCard({
                product,
                index,
                type: 'results',
              })
            })
          } else {
            list.innerHTML = ''
            products.forEach((product, index) => {
              const listItem = document.createElement('li')
              listItem.className = 'prd-List_Item'
              listItem.innerHTML = window.theme.results.templates.ProductCard({
                product,
                index,
                type: 'results',
              })
              list.appendChild(listItem)
            })
          }
        }

        if (interaction === 'pagination') {
          const fragment = document.createDocumentFragment()
          products.forEach((product, index) => {
            const listItem = document.createElement('li')
            listItem.className = 'prd-List_Item'
            listItem.innerHTML = window.theme.results.templates.ProductCard({
              product,
              index,
              type: 'results',
            })
            fragment.appendChild(listItem)
          })
          list.appendChild(fragment)
        }

        list.style.contentVisibility = ''

        this.trackingEvents()
      }

      trackingEvents () {
        let type = 'serp'

        if (
          window.location.pathname.includes('/collections/') &&
          !window.location.pathname.includes('/search')
        ) {
          type = 'category'
        }

        this.querySelectorAll('product-card a').forEach(link => {
          link.addEventListener('click', event => {
            const card = link.closest('product-card')

            this.eventBus.publish(
              window.theme.results.events.TRACKING.PRODUCT_CLICKED,
              {
                hit: {
                  productId: card.getAttribute('data-product-id'),
                  url: link.href,
                },
                type,
              },
            )
          })
        })
      }
    },
  )
}
